import BaseModel from '../core/BaseModel'
//import UserModel from '@/models/UserModel'
export default class ShowroomsModel extends BaseModel {

    constructor() {
        super({
                name: "showrooms",
                tableName: 'showrooms',
                label: "showrooms",
                display_key: 'name'

            },
            {
                stt: {
                    name: "stt",
                    label: "No.",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display : false,
                },
                name: {
                    name: 'name',
                    type: "String",
                    label: "Name",
                    filter: {type: 'input', match: 'contains'},
                    class:"left",
                },
                address: {
                    name: 'address',
                    type: "String",
                    label: "Address",
                    filter: {type: 'input', match: 'contains'},
                    class:"left",
                },
                manager_uid: {
                    name: 'manager_uid',
                    type: "Uid",
                    label: "Management",
                    filter: {type: 'input', match: 'contains'},
                    class:"left",
                },
                ordinal: {
                    name: 'ordinal',
                    type: "String",
                    label: "Order",
                    class:"left",
                },
                active: {
                    name: "active",
                    label: "Active",
                    type: "Selection",
                    custom: 'SelectionText',
                    options: [
                        {value: 'true', label: 'Yes', style: 'color:  #000000;'},
                        {value: 'false', label: 'No',style: 'color:  #000000;'}
                    ],
                    filter: {
                        type: 'select',
                        optionLabel: 'label',
                        optionKey: 'value',
                        match: 'equals'
                    },
                    class:"center",
                    width : 5,
                },
                updated_by: {
                    name: 'updated_by',
                    type: "String",
                    label: "Updated By",
                    class:"left",
                },
                updated_at: {
                    name: 'updated_at',
                    type: "String",
                    label: "Updated date",
                    class:"left",
                },
                detail_get: {
                    refs:  ' manager { id fullname }  obj_update { id fullname } ',
                    display: false
                },
                detail_get1: {
                    refs:  ' note ordinal ',
                    display: false
                },
            })
    }

}